import {
  UserManager,
  UserManagerSettings,
  UserManagerSettingsStore,
} from 'oidc-client-ts'
import useUserManagerSettings from './useUseManagerSettings'
import { Log } from 'oidc-client-ts'
import { Navigator } from '@/helpers/Navigator'
import { Browser } from '@capacitor/browser'
import { Capacitor } from '@capacitor/core'
import { getIS4BaseUrl } from '@/helpers/env'

export default class AuthService {
  settings: UserManagerSettings
  userManager: UserManager

  constructor() {
    this.settings = useUserManagerSettings()

    this.userManager = new UserManager(
      this.settings,
      new Navigator(new UserManagerSettingsStore(this.settings)),
    )

    // Set debug to true to see console logs
    const debug = false

    if (debug) {
      Log.setLevel(Log.DEBUG)
      Log.setLogger(console)
    }
  }

  async isLoggedInAsync() {
    return await this.userManager.getUser().then((user) => {
      return user != null && !user.expired
    })
  }

  async silentLogin() {
    await this.userManager.signinSilent()
  }

  async getUserAsync() {
    return await this.userManager.getUser()
  }

  async getUserIdAsync() {
    return await this.userManager.getUser().then((data) => {
      return data?.profile?.sub
    })
  }

  async loginAsync(redirectUrl: string | null = null) {
    return this.userManager.signinRedirect({
      state: redirectUrl ?? window.location.href,
    })
  }

  async logoutAsync(redirectUrl: string | null = null) {
    await this.userManager.signoutRedirect({
      state: redirectUrl ?? window.location.href,
    })
  }

  async getAccessTokenAsync() {
    return await this.userManager.getUser().then((data) => {
      return data?.id_token
    })
  }

  async clearStaleStateAsync() {
    await this.userManager.clearStaleState()
  }

  async registerAsync() {
    const url = `${getIS4BaseUrl()}/Identity/Account/Register`
    if (Capacitor.isNativePlatform()) {
      await Browser.open({
        url: url,
      })
    } else {
      window.location.href = url
    }
  }
}

const authService = new AuthService()
export const useAuthService = () => authService
